import { ref } from 'vue';

export function useSpeech(
  text,
  root
){
  const temporalSpeech = ref('');
  const lastPersistedText = ref(null);

  const startSpeech = () => {
    // console.log('start speech');
    lastPersistedText.value = text.value;
  }

  const updateInput = (speech) => {
    temporalSpeech.value = speech;
    if(speech){
      text.value = lastPersistedText.value + ' ' + temporalSpeech.value;
    }
  };

  const endSpeech = () => {
    // console.log('endSpeech');
    temporalSpeech.value = '';
  }

  const stopSpeech = () => {
    root.proxy.$refs?.recognition?.stop();
    root.proxy.$refs?.vuetifyApp?.stopSpeech();
  }


  return {
    updateInput,
    stopSpeech,
    startSpeech,
    endSpeech
  }
}

